import React, { useEffect, useState } from "react";
import Chip from "@mui/material/Chip";
import PhotoSizeSelectActualOutlinedIcon from "@mui/icons-material/PhotoSizeSelectActualOutlined";
import OndemandVideoOutlinedIcon from "@mui/icons-material/OndemandVideoOutlined";
import { Avatar, Box } from "@mui/material";
import { s3baseUri } from "../../config/config";
import { img_icon, vid_icon } from "../../assets";

function OpenCreatePostCard({
  handleOpenSimpleBox,
  userInfo,
  handleOpenImageBox,
  handleOpenVideoBox,
}) {
  const [isMobile, setIsMobile] = useState(false);

  // Replacing MUI useMediaQuery with standard matchMedia
  useEffect(() => {
    const mediaCheck = window.matchMedia("(max-width: 576px)");
    setIsMobile(mediaCheck.matches);
    const listener = (e) => setIsMobile(e.matches);
    mediaCheck.addListener(listener);
    return () => mediaCheck.removeListener(listener);
  }, []);

  return (
    <div className="mb-3">
      <div className="card-1 p-3">
        {/* Profile + Create Post */}
        <div className="input-with-profile d-flex w-100 align-items-center justify-content-betwee flex-nowrap">
          <div>
            <Avatar
              className="profile-img"
              src={
                s3baseUri +
                userInfo?.company_profile?.profile_image?.thumbnail_1
              }
            />
          </div>

          <div className="w-100">
            <div className="input-field ms-2 d-flex flex-nowrap justify-content-between w-100">
              <div
                className="overflow-hidden w-100"
                onClick={handleOpenSimpleBox}
              >
                <span>
                  What’s on your mind,{" "}
                  {userInfo?.company_profile?.company_name ||
                    userInfo.company_name}
                  ?
                </span>
              </div>
              <div className="actions-icons">
                <div className="border-cut"></div>
                <div>
                  <img
                    onClick={handleOpenImageBox}
                    src={img_icon}
                    alt="image-icon"
                  />
                </div>
                <div>
                  <img
                    onClick={handleOpenVideoBox}
                    src={vid_icon}
                    alt="vid-icon"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OpenCreatePostCard;
